// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/cv-pro/cv-pro-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/cv-pro/cvpro-mob-banner.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cv-pro-top-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 28.2vw;
}
.cvpro-banner-content-wrapper img {
  height: 80px;
  width: auto;
  margin-left: -15px;
}

.cvpro-comp-sec {
  padding: 0 5%;
}

.cv-pro-meet-vid {
  margin-top: 20px;
}

.cvpro-banner-content-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -70%);
}

.cvpro-intro {
  font-size: 25px;
  font-weight: 600;
}

.abt-cvpro {
  font-weight: 500;
  padding-right: 20px;
}

/* Meet CV Pro  */
.char-img img {
  height: 450px;
  width: auto;
}

.cvpro-sub-head p {
  font-size: 30px;
}

.about-cv-pro p {
  text-align: justify;
  padding: 5% 0%;
}

.cv-pro-meet-vid {
  padding: 15%;
  position: relative;
  margin-bottom: 30px;
}

.cv-pro-meet-vid iframe {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
}

/* 3 CV Pro different packs */
.cvpro-packs {
  background-color: #f5f6fb;
}
.cvpro-subhead p {
  color: #5d5d5f;
  font-size: 25px;
}

/* .packs-container {
  padding: 0 10%;
} */

.cvpro-pack-card {
  border: medium none currentColor;
  border: initial;
  border-radius: 50px;
}

.cvpro-pack-a {
  background-color: #b6c534;
}

.cvpro-pack-b {
  background-color: #7b51b0;
}

.cvpro-pack-c {
  background-color: #01b9d6;
}

.cvpro-pack-card img {
  position: absolute;
  bottom: 63%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
  width: 100%;
}

.cvpro-pack-a img {
  height: 220px;
  width: auto;
}

.abt-cvpro-packs {
  height: 330px;
}
.cvpro-pack-name {
  color: #fff;
  font-size: 30px;
  font-weight: 900;
  text-align: center;
  padding: 5%;
}

.cvpro-pack-name-c {
  padding: 5% 20%;
}

.abt-cvpro-packs {
  background-color: #fff;
  border-radius: 25px;
  padding: 20px;
}

.abt-cvpro-packs p {
  color: #000;
  font-weight: 600;
}

.course-duration {
  padding-left: 30px;
}

.abt-cvpro-packs ul {
  margin-bottom: 0px;
}

.abt-cvpro-packs ul li {
  font-weight: 600;
}

.cvpro-no-txt p {
  font-size: 30px;
  font-weight: 900;
  text-align: center;
  padding-top: 5%;
}

.cvpro-no-txt-a p {
  color: #b6c534;
}

.cvpro-no-txt-b p {
  color: #7b51b0;
}

.cvpro-no-txt-c p {
  color: #01b9d6;
}

.get-cvpro p {
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 0px;
}

/* Addons section */
.cvpro-pack-addons {
  background-color: #f5f6fb;
}
.cvpro-mat-txt-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}

.training-mat-txt {
  border-right: 1px solid black;
  padding: 0px 15px;
}

.training-mat-txt p {
  margin-bottom: 0px;
}

.addons-txt p {
  margin-bottom: 0px;
  padding-left: 10px;
  font-size: 40px;
  font-weight: 700;
}

.training-mat-img img {
  height: 350px;
  width: auto;
  padding-bottom: 30px;
}

.sign-boards-img img {
  height: 200px;
  width: auto;
}

.cvpro-tm-txt p {
  padding-top: 30px;
  font-weight: 500;
}

.cvpro-mecan-wheels-img img {
  height: 250px;
  width: auto;
}

.cvpro-mw-text-wrapper p {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.5;
}

.cvpro-mw-text-wrapper p:nth-child(2) {
  font-weight: 400;
}

.wheel-text-wrapper {
  display: flex;
  align-items: center;
  column-gap: 20px;
  justify-content: center;
}

.macanum-wheel-img img,
.wheel-connect-img img {
  height: 120px;
  width: auto;
}

.x4-text p {
  font-size: 30px;
  font-weight: 700;
}

.availability-text p {
  font-weight: 700;
}

.cvpro-head-cstm {
  padding-left: 14%;
}

/* .cvpro-comp-wrapper {
  padding: 0 6%;
} */

/* CV Pro at Global events */
.g-event-txt {
  background-color: #f5f6fb;
  padding: 20px 40px;
  height: 100%;
  /* margin-top: 13%; */
}

.event-que {
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
}

/* Operational techniques */
.ot-container {
  padding: 0 15%;
}
.operational-techniques {
  background-color: #f5f6fb;
}

.ot-wrapper ul {
  list-style-type: none;
}

.ot-wrapper ul li {
  padding-bottom: 10px;
  font-weight: 600;
}

.ot-wrapper ul li svg {
  color: var(--dBlue);
  font-size: 18px;
}

.cvpro-work-with-logos {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 20px 0px;
  margin: 0 20px;
  border-bottom: 1px solid #dadada;
}

.cvpro-work-with-logos-wrapper {
  border-right: 1px solid #dadada;
}

.cvpro-work-with-logo-a img,
.cvpro-work-with-logo-b img {
  height: 80px;
  width: 100%;
}

.cvpro-flutter img {
  height: 40px;
}

.cv-border-bottom {
  border-bottom: 0;
  border-bottom: initial;
}

.why-cv-pro-txt {
  padding: 5%;
  text-align: center;
}

.cvpro-img-wrapper img {
  height: auto;
  width: 50%;
}

/* Autonomous navigation tech */
.autonomous-nav-tech {
  background-color: #f5f6fb;
}

.tech-img-text-wrapper {
  text-align: center;
}

.tech-image-wrap img {
  height: auto;
  width: 70%;
}

.tech-content-wrap {
  padding-top: 10px;
}

.tech-content-wrap p {
  font-weight: 600;
  color: #404146;
  padding: 0 30px;
  line-height: 1.3;
}

/* Who is CV Pro for  */
.cvpro-for-container {
  padding: 0 10%;
}
.who-is-cvpro-img-wrapper img {
  height: 80px;
  width: auto;
}

.wciw-custom-height img {
  height: 60px;
  margin-top: 20px;
}

.who-is-cvpro-text-wrapper {
  padding: 20px 35px;
}

.who-is-cvpro-text-wrapper p {
  font-weight: 600;
}

.event-ans {
  text-align: justify;
}

@media (max-width: 1024px) {
  .cvpro-banner-content-wrapper img {
    height: 50px;
    margin-left: -8px;
  }

  .cvpro-banner-content-wrapper {
    left: 55%;
    transform: translate(-100%, -65%);
  }

  .cvpro-pack-a img {
    height: 200px;
  }

  .cvpro-img-b,
  .cvpro-img-c {
    text-align: center;
  }

  .cvpro-img-b img {
    height: auto;
    width: 100%;
  }

  .packs-container {
    padding: 0;
    padding: initial;
  }

  .cvpro-pack-c {
    margin-top: 150px;
  }

  .tech-img-text-wrapper {
    padding-bottom: 20px;
  }

  .who-is-cvpro-text-wrapper {
    padding: 15px 0px;
  }

  .who-is-cvpro-for-card-wrapper {
    padding-bottom: 20px;
  }

  .ot-container {
    padding: 0 5%;
  }

  .addons-txt p {
    font-size: 20px;
  }

  .training-mat-img img,
  .sign-boards-img img,
  .cvpro-mecan-wheels-img img {
    height: auto;
    width: 80%;
  }

  .cvpro-mw-text-wrapper p {
    font-size: 22px;
  }

  .macanum-wheel-img img,
  .wheel-connect-img img {
    height: auto;
    width: 50%;
  }

  .wheel-text-wrapper {
    text-align: center;
  }

  .mt-neg-15 {
    margin-top: -15px;
  }

  .cvpro-work-with-logo-a img,
  .cvpro-work-with-logo-b img {
    height: 45px;
    width: auto;
  }

  .tech-content-wrap p {
    padding: 0;
    padding: initial;
  }

  .cvpro-for-container {
    padding: 0;
    padding: initial;
  }

  .who-is-cvpro-img-wrapper img {
    width: 100%;
  }

  .who-is-cvpro-text-wrapper p {
    font-weight: 500;
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .cv-pro-top-banner {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 127.2vw;
  }

  .cvpro-banner-content-wrapper {
    position: absolute;
    top: 25%;
    left: 10%;
    transform: translate(0%, -60%);
  }

  .char-img img {
    height: auto;
    width: 100%;
  }

  .about-cv-pro p {
    padding: 5%;
  }

  .sign-boards-img img {
    height: auto;
    width: 100%;
  }

  .cvpro-img-b,
  .cvpro-img-c {
    text-align: center;
  }

  .cvpro-img-b img {
    height: 150px;
    width: auto;
  }

  .cvpro-img-c img {
    height: 250px;
    width: auto;
    margin-top: -40px;
  }

  .packs-container {
    padding: 0 5%;
  }

  .cvpro-pack-a img {
    height: 200px !important;
    width: auto !important;
  }

  .cvpro-pack-b img {
    height: 200px !important;
    width: auto !important;
  }

  .cvpro-pack-b,
  .cvpro-pack-c {
    margin-top: 100px;
  }

  .addons-txt p {
    font-size: 25px;
  }

  .cvpro-mecan-wheels-img img {
    height: 200px;
  }

  .macanum-wheel-img img,
  .wheel-connect-img img {
    height: 90px;
  }

  .g-event-txt {
    padding: 20px 30px;
  }

  .ot-container {
    padding: 0 5%;
  }

  .cvpro-work-with-logo-a img,
  .cvpro-work-with-logo-b img {
    height: 40px;
    width: auto;
  }

  .cvpro-work-with-logos-wrapper {
    border-right: 0;
    border-right: initial;
  }

  .tech-img-text-wrapper {
    padding-bottom: 20px;
  }

  .who-is-cvpro-text-wrapper {
    padding: 10px 35px;
    margin-bottom: 20px;
  }

  .mt-neg-15 {
    margin-top: -15px;
  }

  .cvpro-comp-wrapper {
    flex-wrap: wrap;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/indivdual-product-pages/CV Pro/CVPro.css"],"names":[],"mappings":"AAAA;EACE,yDAA2E;EAC3E,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,gCAAa;EAAb,eAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAoB;EAApB,sBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,UAAc;IAAd,gBAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yDAA8E;IAC9E,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAmB;IAAnB,qBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":[".cv-pro-top-banner {\n  background-image: url(\"../../../../public/images/cv-pro/cv-pro-banner.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 28.2vw;\n}\n.cvpro-banner-content-wrapper img {\n  height: 80px;\n  width: auto;\n  margin-left: -15px;\n}\n\n.cvpro-comp-sec {\n  padding: 0 5%;\n}\n\n.cv-pro-meet-vid {\n  margin-top: 20px;\n}\n\n.cvpro-banner-content-wrapper {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-100%, -70%);\n}\n\n.cvpro-intro {\n  font-size: 25px;\n  font-weight: 600;\n}\n\n.abt-cvpro {\n  font-weight: 500;\n  padding-right: 20px;\n}\n\n/* Meet CV Pro  */\n.char-img img {\n  height: 450px;\n  width: auto;\n}\n\n.cvpro-sub-head p {\n  font-size: 30px;\n}\n\n.about-cv-pro p {\n  text-align: justify;\n  padding: 5% 0%;\n}\n\n.cv-pro-meet-vid {\n  padding: 15%;\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.cv-pro-meet-vid iframe {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n}\n\n/* 3 CV Pro different packs */\n.cvpro-packs {\n  background-color: #f5f6fb;\n}\n.cvpro-subhead p {\n  color: #5d5d5f;\n  font-size: 25px;\n}\n\n/* .packs-container {\n  padding: 0 10%;\n} */\n\n.cvpro-pack-card {\n  border: unset;\n  border-radius: 50px;\n}\n\n.cvpro-pack-a {\n  background-color: #b6c534;\n}\n\n.cvpro-pack-b {\n  background-color: #7b51b0;\n}\n\n.cvpro-pack-c {\n  background-color: #01b9d6;\n}\n\n.cvpro-pack-card img {\n  position: absolute;\n  bottom: 63%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: auto;\n  width: 100%;\n}\n\n.cvpro-pack-a img {\n  height: 220px;\n  width: auto;\n}\n\n.abt-cvpro-packs {\n  height: 330px;\n}\n.cvpro-pack-name {\n  color: #fff;\n  font-size: 30px;\n  font-weight: 900;\n  text-align: center;\n  padding: 5%;\n}\n\n.cvpro-pack-name-c {\n  padding: 5% 20%;\n}\n\n.abt-cvpro-packs {\n  background-color: #fff;\n  border-radius: 25px;\n  padding: 20px;\n}\n\n.abt-cvpro-packs p {\n  color: #000;\n  font-weight: 600;\n}\n\n.course-duration {\n  padding-left: 30px;\n}\n\n.abt-cvpro-packs ul {\n  margin-bottom: 0px;\n}\n\n.abt-cvpro-packs ul li {\n  font-weight: 600;\n}\n\n.cvpro-no-txt p {\n  font-size: 30px;\n  font-weight: 900;\n  text-align: center;\n  padding-top: 5%;\n}\n\n.cvpro-no-txt-a p {\n  color: #b6c534;\n}\n\n.cvpro-no-txt-b p {\n  color: #7b51b0;\n}\n\n.cvpro-no-txt-c p {\n  color: #01b9d6;\n}\n\n.get-cvpro p {\n  font-size: 25px;\n  font-weight: 600;\n  margin-bottom: 0px;\n}\n\n/* Addons section */\n.cvpro-pack-addons {\n  background-color: #f5f6fb;\n}\n.cvpro-mat-txt-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 30px;\n}\n\n.training-mat-txt {\n  border-right: 1px solid black;\n  padding: 0px 15px;\n}\n\n.training-mat-txt p {\n  margin-bottom: 0px;\n}\n\n.addons-txt p {\n  margin-bottom: 0px;\n  padding-left: 10px;\n  font-size: 40px;\n  font-weight: 700;\n}\n\n.training-mat-img img {\n  height: 350px;\n  width: auto;\n  padding-bottom: 30px;\n}\n\n.sign-boards-img img {\n  height: 200px;\n  width: auto;\n}\n\n.cvpro-tm-txt p {\n  padding-top: 30px;\n  font-weight: 500;\n}\n\n.cvpro-mecan-wheels-img img {\n  height: 250px;\n  width: auto;\n}\n\n.cvpro-mw-text-wrapper p {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.5;\n}\n\n.cvpro-mw-text-wrapper p:nth-child(2) {\n  font-weight: 400;\n}\n\n.wheel-text-wrapper {\n  display: flex;\n  align-items: center;\n  column-gap: 20px;\n  justify-content: center;\n}\n\n.macanum-wheel-img img,\n.wheel-connect-img img {\n  height: 120px;\n  width: auto;\n}\n\n.x4-text p {\n  font-size: 30px;\n  font-weight: 700;\n}\n\n.availability-text p {\n  font-weight: 700;\n}\n\n.cvpro-head-cstm {\n  padding-left: 14%;\n}\n\n/* .cvpro-comp-wrapper {\n  padding: 0 6%;\n} */\n\n/* CV Pro at Global events */\n.g-event-txt {\n  background-color: #f5f6fb;\n  padding: 20px 40px;\n  height: 100%;\n  /* margin-top: 13%; */\n}\n\n.event-que {\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n/* Operational techniques */\n.ot-container {\n  padding: 0 15%;\n}\n.operational-techniques {\n  background-color: #f5f6fb;\n}\n\n.ot-wrapper ul {\n  list-style-type: none;\n}\n\n.ot-wrapper ul li {\n  padding-bottom: 10px;\n  font-weight: 600;\n}\n\n.ot-wrapper ul li svg {\n  color: var(--dBlue);\n  font-size: 18px;\n}\n\n.cvpro-work-with-logos {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  padding: 20px 0px;\n  margin: 0 20px;\n  border-bottom: 1px solid #dadada;\n}\n\n.cvpro-work-with-logos-wrapper {\n  border-right: 1px solid #dadada;\n}\n\n.cvpro-work-with-logo-a img,\n.cvpro-work-with-logo-b img {\n  height: 80px;\n  width: 100%;\n}\n\n.cvpro-flutter img {\n  height: 40px;\n}\n\n.cv-border-bottom {\n  border-bottom: unset;\n}\n\n.why-cv-pro-txt {\n  padding: 5%;\n  text-align: center;\n}\n\n.cvpro-img-wrapper img {\n  height: auto;\n  width: 50%;\n}\n\n/* Autonomous navigation tech */\n.autonomous-nav-tech {\n  background-color: #f5f6fb;\n}\n\n.tech-img-text-wrapper {\n  text-align: center;\n}\n\n.tech-image-wrap img {\n  height: auto;\n  width: 70%;\n}\n\n.tech-content-wrap {\n  padding-top: 10px;\n}\n\n.tech-content-wrap p {\n  font-weight: 600;\n  color: #404146;\n  padding: 0 30px;\n  line-height: 1.3;\n}\n\n/* Who is CV Pro for  */\n.cvpro-for-container {\n  padding: 0 10%;\n}\n.who-is-cvpro-img-wrapper img {\n  height: 80px;\n  width: auto;\n}\n\n.wciw-custom-height img {\n  height: 60px;\n  margin-top: 20px;\n}\n\n.who-is-cvpro-text-wrapper {\n  padding: 20px 35px;\n}\n\n.who-is-cvpro-text-wrapper p {\n  font-weight: 600;\n}\n\n.event-ans {\n  text-align: justify;\n}\n\n@media (max-width: 1024px) {\n  .cvpro-banner-content-wrapper img {\n    height: 50px;\n    margin-left: -8px;\n  }\n\n  .cvpro-banner-content-wrapper {\n    left: 55%;\n    transform: translate(-100%, -65%);\n  }\n\n  .cvpro-pack-a img {\n    height: 200px;\n  }\n\n  .cvpro-img-b,\n  .cvpro-img-c {\n    text-align: center;\n  }\n\n  .cvpro-img-b img {\n    height: auto;\n    width: 100%;\n  }\n\n  .packs-container {\n    padding: unset;\n  }\n\n  .cvpro-pack-c {\n    margin-top: 150px;\n  }\n\n  .tech-img-text-wrapper {\n    padding-bottom: 20px;\n  }\n\n  .who-is-cvpro-text-wrapper {\n    padding: 15px 0px;\n  }\n\n  .who-is-cvpro-for-card-wrapper {\n    padding-bottom: 20px;\n  }\n\n  .ot-container {\n    padding: 0 5%;\n  }\n\n  .addons-txt p {\n    font-size: 20px;\n  }\n\n  .training-mat-img img,\n  .sign-boards-img img,\n  .cvpro-mecan-wheels-img img {\n    height: auto;\n    width: 80%;\n  }\n\n  .cvpro-mw-text-wrapper p {\n    font-size: 22px;\n  }\n\n  .macanum-wheel-img img,\n  .wheel-connect-img img {\n    height: auto;\n    width: 50%;\n  }\n\n  .wheel-text-wrapper {\n    text-align: center;\n  }\n\n  .mt-neg-15 {\n    margin-top: -15px;\n  }\n\n  .cvpro-work-with-logo-a img,\n  .cvpro-work-with-logo-b img {\n    height: 45px;\n    width: auto;\n  }\n\n  .tech-content-wrap p {\n    padding: unset;\n  }\n\n  .cvpro-for-container {\n    padding: unset;\n  }\n\n  .who-is-cvpro-img-wrapper img {\n    width: 100%;\n  }\n\n  .who-is-cvpro-text-wrapper p {\n    font-weight: 500;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .cv-pro-top-banner {\n    background-image: url(\"../../../../public/images/cv-pro/cvpro-mob-banner.png\");\n    height: 127.2vw;\n  }\n\n  .cvpro-banner-content-wrapper {\n    position: absolute;\n    top: 25%;\n    left: 10%;\n    transform: translate(0%, -60%);\n  }\n\n  .char-img img {\n    height: auto;\n    width: 100%;\n  }\n\n  .about-cv-pro p {\n    padding: 5%;\n  }\n\n  .sign-boards-img img {\n    height: auto;\n    width: 100%;\n  }\n\n  .cvpro-img-b,\n  .cvpro-img-c {\n    text-align: center;\n  }\n\n  .cvpro-img-b img {\n    height: 150px;\n    width: auto;\n  }\n\n  .cvpro-img-c img {\n    height: 250px;\n    width: auto;\n    margin-top: -40px;\n  }\n\n  .packs-container {\n    padding: 0 5%;\n  }\n\n  .cvpro-pack-a img {\n    height: 200px !important;\n    width: auto !important;\n  }\n\n  .cvpro-pack-b img {\n    height: 200px !important;\n    width: auto !important;\n  }\n\n  .cvpro-pack-b,\n  .cvpro-pack-c {\n    margin-top: 100px;\n  }\n\n  .addons-txt p {\n    font-size: 25px;\n  }\n\n  .cvpro-mecan-wheels-img img {\n    height: 200px;\n  }\n\n  .macanum-wheel-img img,\n  .wheel-connect-img img {\n    height: 90px;\n  }\n\n  .g-event-txt {\n    padding: 20px 30px;\n  }\n\n  .ot-container {\n    padding: 0 5%;\n  }\n\n  .cvpro-work-with-logo-a img,\n  .cvpro-work-with-logo-b img {\n    height: 40px;\n    width: auto;\n  }\n\n  .cvpro-work-with-logos-wrapper {\n    border-right: unset;\n  }\n\n  .tech-img-text-wrapper {\n    padding-bottom: 20px;\n  }\n\n  .who-is-cvpro-text-wrapper {\n    padding: 10px 35px;\n    margin-bottom: 20px;\n  }\n\n  .mt-neg-15 {\n    margin-top: -15px;\n  }\n\n  .cvpro-comp-wrapper {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
